import { create } from 'zustand';
import videosData from '../data/videos.json';

const useVideoStore = create((set) => ({
  videos: [],
  isLoading: false,
  error: null,

  fetchVideos: async () => {
    set({ isLoading: true, error: null });
    try {
      const publishedVideos = videosData
        .filter(video => video.status === 'published')
        .sort((a, b) => a.display_order - b.display_order);

      set({ videos: publishedVideos, isLoading: false });
      return publishedVideos;
    } catch (error) {
      console.error('Error loading videos:', error);
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  clearError: () => set({ error: null })
}));

export default useVideoStore;
